import { useMediaQuery } from '@mui/material';
import { BlockWrapper } from '@smartfire/js-block-engine';
import style from './block.module.scss';
import React from 'react';
import { timerQuiz } from '../components/utils';

const Block = ({ post }) => {
    const isMobile = useMediaQuery(`(max-width : ${style.mobileBreakpoint})`);
    const isTablet = useMediaQuery(`(max-width : ${style.tabletBreakpoint})`);
    const desktopImageURL = post.cover_picture;
    const mobileImageURL = post.mini_picture;

    return (
        <BlockWrapper.Div
            className={style.block}
            style={{ backgroundImage: `url(${isMobile ? mobileImageURL : desktopImageURL})` }}
        >
            <div className={style.backgrounds}>
                <div className={style.top} />
                <div className={style.bottom} />
                {!isTablet && (
                    <>
                        <div className={style.left} />
                        <div className={style.right} />
                    </>
                )}

                {isTablet && (
                    <>
                        <div className={style.topLeft} />
                        <div className={style.topRight} />
                        <div className={style.bottomRight} />
                    </>
                )}
            </div>
            <div className={style.container}>
                <div className={style.rank}>
                    <img src={post.requiredRankImage} alt={post.requiredRankName} />
                    <span className={style.rankName}>Niveau {post.requiredRankName}</span>
                </div>
                <h1 className={style.title}>{post.title}</h1>
                <div className={style.row}>
                    <div className={style.timer}>{timerQuiz(post.expiration)}</div>
                    <div className={style.separator} />
                    <div className={style.points}>
                        ⭐️ <span>+100</span> Points
                    </div>
                </div>
            </div>
        </BlockWrapper.Div>
    );
};

export default Block;
